import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar,IonItem, IonLabel,IonText,IonButtons,IonButton } from '@ionic/react';
import AuctionsGrid from '../components/AuctionsGrid';
import './Dashboard.css';
import  NavComponent  from "../components/NavComponent";
import {AuthUser} from "aws-amplify/auth";

const Dashboard  = ({user}:{user:AuthUser}) => {
  return (
    <IonPage>      
      <IonContent fullscreen>
        <IonToolbar>
            <IonTitle ><img src="assets/images/MADfreight-logo.png" alt="logo" /></IonTitle>  
            <NavComponent />
        </IonToolbar>  
        <IonItem>
            <IonLabel className="ion-text-wrap">
              <IonText color="primary">
                <h2>Recent Wins / Needs Shipping</h2>
              </IonText>              
            </IonLabel>
          </IonItem>        
        <AuctionsGrid user={user}  />
        <IonItem>
            <IonLabel className="ion-text-wrap">
              <IonText color="primary">
                <h2>My Active Auctions</h2>
              </IonText>              
            </IonLabel>
          </IonItem>        
        <AuctionsGrid   user={user} />
      </IonContent>
    </IonPage>
  );
};

export default Dashboard;
